// auth.js - React Query hooks for authentication operations
// Following mob-fe architecture pattern (api.ts equivalent)
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  registerUser,
  sendVerificationEmail,
  verifyEmailCode,
  sendPasswordResetEmail,
} from '../utils/api';

// Register user mutation
export const useRegisterMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ email, password, name, surname }) => {
      // This will be called after Firebase createUserWithEmailAndPassword
      return await registerUser(email, password, name, surname);
    },
    onSuccess: (data, variables) => {
      // Optionally cache user data or trigger other actions
      console.log('User registered successfully:', data);
    },
    onError: (error) => {
      console.error('Registration error:', error.message);
    },
  });
};

// Send verification email mutation
export const useSendVerificationEmailMutation = () => {
  return useMutation({
    mutationFn: async (email) => {
      return await sendVerificationEmail(email);
    },
    onSuccess: (data) => {
      console.log('Verification email sent:', data);
    },
    onError: (error) => {
      console.error('Failed to send verification email:', error.message);
    },
  });
};

// Verify email code mutation
export const useVerifyEmailMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ email, code }) => {
      return await verifyEmailCode(email, code);
    },
    onSuccess: (data, variables) => {
      console.log('Email verified successfully:', data);
      // Invalidate user details to refetch with updated verification status
      queryClient.invalidateQueries({ queryKey: ['userDetails', variables.email] });
    },
    onError: (error) => {
      console.error('Email verification error:', error.message);
    },
  });
};

// Send password reset email mutation
export const useSendPasswordResetMutation = () => {
  return useMutation({
    mutationFn: async (email) => {
      return await sendPasswordResetEmail(email);
    },
    onSuccess: (data) => {
      console.log('Password reset email sent:', data);
    },
    onError: (error) => {
      console.error('Failed to send password reset email:', error.message);
    },
  });
};
